import React, { FC } from 'react'
import { InputGroup, Position } from '@blueprintjs/core'
import { Icon, ApolloDayPicker, Popover } from '@ui'
import noop from 'lodash/noop'
import { DateUtil } from '@utils/dateUtil'
import css from './apolloDateInput.module.scss'

type ApolloDateInputProps = {
  value: Date | null
  selectedFromDate: Date | null
  selectedToDate: Date | null
  disabledBefore: Date | null
  disabledAfter: Date | null
  defaultMonth?: Date
  onDayClick: (date: Date) => void
  onInputChange?: (event: React.FormEventHandler<HTMLElement>) => void
}

const ApolloDateInput: FC<ApolloDateInputProps> = ({
  onDayClick,
  value,
  selectedFromDate,
  selectedToDate,
  disabledBefore,
  disabledAfter,
  defaultMonth = DateUtil().toDate(),
  onInputChange = noop,
}) => {
  return (
    <Popover
      minimal
      popoverClassName={css.popover}
      position={Position.BOTTOM_LEFT}
      modifiers={{
        offset: { options: { offset: [0, 8] } },
      }}
    >
      <InputGroup
        fill
        value={value ? DateUtil(value).format('MM/dd/yyyy') : ''}
        onChange={onInputChange}
        placeholder="mm/dd/yyyy"
        rightElement={<Icon name="calendar" />}
      />
      <ApolloDayPicker
        mode="range"
        defaultMonth={defaultMonth}
        selected={{
          from: selectedFromDate || DateUtil().toDate(),
          to: selectedToDate || DateUtil().toDate(),
        }}
        disabled={{
          before: disabledBefore || DateUtil().toDate(),
          after: disabledAfter || DateUtil().toDate(),
        }}
        onDayClick={onDayClick}
      />
    </Popover>
  )
}

export default ApolloDateInput
